import { AloftPrice, isDefined, orUndefined, schAloftPrice } from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinitionParams } from '../../types.ts';

export const calcSiteToValueRatios = ({
  compAdjustments,
  compSequence,
  improvementCosts,
  propertyDataEntities,
  siteValues,
}: AlertDefinitionParams) => {
  const subjectImprovementCost = improvementCosts.subject;
  const subjectSiteValue = orUndefined(schAloftPrice.parse)(
    (propertyDataEntities.subject as SubjectPropertyDataState | undefined)?.subjectData.editableData
      .opinionOfSiteValue,
  );

  if (!subjectSiteValue || !subjectImprovementCost) return undefined;

  const subjectTotalValue = subjectImprovementCost.add(subjectSiteValue);
  const subjectRatio = subjectSiteValue.ratio(subjectTotalValue);

  const compRatios: number[] = compSequence
    .map((id) => {
      const adjustments = compAdjustments[id];
      const siteValue = siteValues[id];
      if (!adjustments || !siteValue) return undefined;

      const compMarketAdj = AloftPrice.addWithNulls(
        adjustments.dateOfSale.adjustment,
        adjustments.concessions.adjustment,
        adjustments.termsOfSale.adjustment,
      );

      const compValue = orUndefined(schAloftPrice.parse)(
        (propertyDataEntities[id] as CompPropertyDataState | undefined)?.compData.editableData
          .transaction.price,
      )?.add(compMarketAdj);

      return siteValue.ratio(compValue);
    })
    .filter(isDefined);

  if (compRatios.length < 2) return undefined;

  const maxCompRatio = Math.max(...compRatios);
  const minCompRatio = Math.min(...compRatios);

  return {
    subjectRatio,
    minCompRatio,
    maxCompRatio,
  };
};
